import React from 'react';
import styled from 'styled-components';
import CertificateIcon from 'images/claims/certificate.svg';
import { ChevronRight } from '@styled-icons/bootstrap/ChevronRight';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { formatDateString } from 'utils/date';
const Container = styled.a `
  display: flex;
  justify-content: flex;
  align-items: center;
  grid-gap: 10px;
  background: white;
  box-shadow: ${({ theme }) => theme.shadows[0]};
  border-left: 8px solid transparent;
  border-radius: 6px;
  padding: 8px 16px;
  text-decoration: none;
  overflow: hidden;
  margin-bottom: 8px;
`;
const TitleContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;
const Title = styled.span `
  color: #000;
  font-weight: 700;
  font-size: 14px;
`;
const SubTitle = styled.span `
  color: ${({ theme }) => theme.backgrounds.grey};
  font-weight: 400;
  font-size: 11px;
`;
const IconContainer = styled.div `
  min-width: 24px;
`;
const DocumentItem = ({ document }) => {
    const { t } = useTranslation();
    const { palette: { primary: { main: themeColor }, }, } = useTheme();
    return (React.createElement(Container, { href: document === null || document === void 0 ? void 0 : document.url, target: document && '_blank' },
        React.createElement(IconContainer, null,
            React.createElement(CertificateIcon, { color: themeColor })),
        React.createElement(TitleContainer, null,
            React.createElement(Title, null, document === null || document === void 0 ? void 0 : document.title),
            document && (React.createElement(SubTitle, null, [
                document.issuedDate &&
                    t('impact-claims.issued', {
                        issued: formatDateString(document.issuedDate),
                    }),
                document.expiryDate &&
                    t('impact-claims.expires', {
                        expires: formatDateString(document.expiryDate),
                    }),
            ]
                .filter((text) => text)
                .join(' - ')))),
        React.createElement(ChevronRight, { size: 16, color: "#AFAFAF" })));
};
export default DocumentItem;
